export default __webpack_public_path__ + "static/media/upload-file.aeb9b700.svg";